/**
 * Prototype-only: a build that shows the statement-download prototype on its
 * own, for sharing — `VITE_PROTOTYPE_SCOPE=statement-download pnpm build`.
 *
 * With it on, every URL lands on Royalty Statements, the sidebar lists only
 * that page, and the dev bar keeps only this prototype's switch. Without it the
 * app is unchanged.
 */
export const STATEMENT_DOWNLOAD_ONLY =
  import.meta.env.VITE_PROTOTYPE_SCOPE === "statement-download";

export const STATEMENT_DOWNLOAD_HOME = "/royalty-statements";
